/* globals translation pa_ingredienser_data subscriptionProductOptions */

import {
  calculateBeautyPoints, calculateTotalOptionalProductPrices, findPrice, findPriceNode, getCookie, loader, scrollTo, setCookie, simulateSimilarInputChanges, triggerEvent, updatePrice,
} from './functions';

const buildScrollContainers = () => {
  // Find all scroll containers (usually the MCB products module)
  Array.from(document.getElementsByClassName('scroll-container')).forEach((container) => {
    const currentElement = container;
    const parentWrapper = container.parentNode;
    const safeSpace = 75;
    const nextButton = document.createElement('button');
    const prevButton = document.createElement('button');

    prevButton.className = 'navigation-button nude prev-product';
    nextButton.className = 'navigation-button nude next-product';

    prevButton.addEventListener('click', (event) => {
      event.preventDefault();
      const listItem = currentElement.querySelector('ul.products > li.product');

      const start = currentElement.scrollLeft;
      const difference = -listItem.offsetWidth * 2;
      const increment = 5;
      const duration = 300;
      let currentTime = 0;

      const animateScroll = () => {
        currentTime += increment;
        currentElement.scrollLeft = Math.easeInOutQuad(currentTime, start, difference, duration);

        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        }
      };

      animateScroll();
    });

    nextButton.addEventListener('click', (event) => {
      event.preventDefault();

      const listItem = currentElement.querySelector('ul.products > li.product');
      const start = currentElement.scrollLeft;
      const difference = listItem.offsetWidth * 2;
      const increment = 5;
      const duration = 300;
      let currentTime = 0;

      const animateScroll = () => {
        currentTime += increment;
        currentElement.scrollLeft = Math.easeInOutQuad(currentTime, start, difference, duration);

        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        }
      };

      animateScroll();
    });

    parentWrapper.classList.add('scroll-container-parent-wrapper');
    parentWrapper.style.position = 'relative';
    parentWrapper.appendChild(prevButton);
    parentWrapper.appendChild(nextButton);

    const checkIfScroll = () => {
      // Check if the div have a scroll, if not: add a class
      if (container.scrollWidth === container.clientWidth) {
        parentWrapper.classList.add('this-is-not-the-scroll-you-are-looking-for');
      } else {
        parentWrapper.classList.remove('this-is-not-the-scroll-you-are-looking-for');
      }
    };

    checkIfScroll();
    window.addEventListener('resize', () => checkIfScroll());
    window.addEventListener('live-shopping-element-added', () => checkIfScroll());

    // This is fixing a timing issue with the MCB product ajax fetcher and the scroll check
    jQuery(document.body).on('mcb-product-fetched', () => {
      checkIfScroll();

      setTimeout(() => {
        checkIfScroll();
      }, 200);
    });

    // When a user is scrolling inside of the module, add includes to start and end based on scroll position
    container.addEventListener('scroll', () => {
      const scrollLength = container.scrollLeft + container.clientWidth + safeSpace;

      // Adds a class when the scroller is getting close to the end
      if (scrollLength > container.scrollWidth) {
        parentWrapper.classList.add('scroll-close-to-end');
      } else {
        parentWrapper.classList.remove('scroll-close-to-end');
      }

      // Adds a class when the scroller have scrolled a bit away from the start
      if (container.scrollLeft > safeSpace) {
        parentWrapper.classList.add('scroll-away-from-start');
      } else {
        parentWrapper.classList.remove('scroll-away-from-start');
      }
    });
  });
};

buildScrollContainers();
jQuery(document.body).on('updated_cart_totals', buildScrollContainers);


// Add a scroll to reviews event for all elements with the class "open-product-reviews"
Array.from(document.getElementsByClassName('open-product-reviews')).forEach((link) => {
  link.addEventListener('click', (event) => {
    event.preventDefault();
    const reviews = document.querySelector('.reviews-wrapper');
    scrollTo(reviews.offsetTop + 100, 600);
  });
});


// Only run this code on a single product site
if (document.body.classList.contains('single-product')) {
  const toggleTip = document.getElementById('toggle-tips');
  const tipsSection = document.getElementById('tips-section');
  const addToCartButton = document.querySelector('.cart .single_add_to_cart_button.button');


  /**
   * Calculate beauty points, this looking for any changes made to the main price
   * If the price is updated, the points will be calculated again.
   *
   * Note: If the point factor is changed, you need to update them inside of the function.
   */
  setTimeout(() => {
    const priceWrapper = document.querySelector('.product .entry-summary .price');
    const oldPrice = findPrice(priceWrapper);
    updatePrice(priceWrapper, oldPrice);
  }, 100);
  calculateBeautyPoints();


  /**
   * Fixes a loading issue with the product gallery not loading correctly
   */
  setTimeout(() => {
    jQuery(window).trigger('resize');
  }, 500);


  /**
   * Tool tip in product bundles
   */
  if (toggleTip) {
    toggleTip.addEventListener('click', (event) => {
      event.preventDefault();
      tipsSection.classList.toggle('display-tip-as-text');
    });
  }


  /**
   * Change text in the add to cart button for products with forced subscription
   */
  if (addToCartButton && addToCartButton.innerText === 'FAST LEVERING') {
    addToCartButton.innerText = translation.buy;
  }


  /**
   * Simulate change events, this is done because of the design where the
   * buying experience is done in different location on a product page
   */
  simulateSimilarInputChanges('ul.product-bundles input.bundled_qty');
  simulateSimilarInputChanges('input.bundled_product_checkbox', 'checkbox');
  simulateSimilarInputChanges('ul.product-bundles select[name^="bundle_attribute_pa_color_"]', 'select');


  /**
   * Update the product price when the price of a bundle is changed
   */
  const bundleData = document.querySelector('.cart.bundle_data');
  if (bundleData) {
    // Used for success/error messages
    const bundleItemsInfo = document.getElementById('bundle-items-info');

    // Fetch the different price locations
    const headerPrice = document.querySelector('.product-header .price');
    const mainPrice = document.querySelector('.product .entry-summary .price');
    const stickyPrice = document.querySelector('.sticky-product-inner .product-price > .price');
    const deliveries = Array.from(document.querySelectorAll('.delivery-price'));
    const subscriptionBasePrice = document.querySelector('.wcsatt-options-product li.subscription-option .subscription-base-price');

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.target.className === 'bundle_error') {
          // Update the message output with the new message
          bundleItemsInfo.innerHTML = mutation.target.outerHTML;
        } else if (mutation.target.className === 'bundle_price') {
          if (mutation.target.innerHTML) {
            // Fetch the total sum of current selected optional products
            const optionalTotal = calculateTotalOptionalProductPrices();

            // Cast the new price html to a element, for querying
            const priceWrapper = document.createElement('span');
            priceWrapper.innerHTML = mutation.target.innerHTML;

            // Fetch the current price for from the mutation
            const currentPrice = findPrice(priceWrapper);
            const totalPrice = currentPrice + optionalTotal;

            deliveries.forEach((delivery) => {
              const deliveryPriceContainer = delivery.querySelector('.price-container');
              if (deliveryPriceContainer) {
                let percentage = 0;

                if (delivery.dataset.subscriptionDiscountPercentage) {
                  percentage = delivery.dataset.subscriptionDiscountPercentage;
                }

                const discount = (percentage / 100) * totalPrice;
                const newPrice = totalPrice - discount;

                updatePrice(deliveryPriceContainer, newPrice);
              }
            });

            // Combine the optional and current price and update the value inside of the price wrapper node
            updatePrice(priceWrapper, totalPrice);

            if (subscriptionBasePrice) {
              updatePrice(subscriptionBasePrice, totalPrice);
            }

            // Insert the new price to the different price locations
            headerPrice.innerHTML = priceWrapper.innerHTML;
            mainPrice.innerHTML = priceWrapper.innerHTML;
            stickyPrice.innerHTML = priceWrapper.innerHTML;
          }
        }
      });
    });

    const observerConfig = {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    };

    observer.observe(bundleData, observerConfig);
  }


  /**
   * Update the product price when the price of a bundle is changed
   */
  const lndaBundleData = document.querySelector('.cart.lnda_bundle_data');
  if (lndaBundleData) {
    // Fetch the different price locations
    // const headerPrice = document.querySelector('.product-header .price');
    // const mainPrice = document.querySelector('.product .entry-summary .price');
    // const stickyPrice = document.querySelector('.sticky-product-inner .product-price > .price');
    // const deliveries = Array.from(document.querySelectorAll('.delivery-price'));
    // const subscriptionBasePrice = document.querySelector('.wcsatt-options-product li.subscription-option .subscription-base-price');
  }


  /** Bundled products
   * The more info button "?" toggle functionality
   */
  Array.from(document.getElementsByClassName('toggle-more-info')).forEach((button) => {
    const currentButton = button;
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const { productId } = button.dataset;
      const moreContainer = document.getElementById(`more-info-container:${productId}`);
      currentButton.classList.toggle('open');
      moreContainer.classList.toggle('open');

      if (currentButton.classList.contains('open')) {
        currentButton.innerText = '×';
      } else {
        currentButton.innerText = '?';
      }
    });
  });


  /**
   * Bundled products
   * Modify quantity on the custom add to cart link
   */
  const customQty = document.querySelector('.bundle_data .custom-quantity input.qty');
  if (customQty) {
    customQty.addEventListener('change', (event) => {
      const customerAddToCartButton = document.getElementById('customer-add-to-cart-button');
      const url = new URL(customerAddToCartButton.href);
      const params = url.search;
      const searchParams = new URLSearchParams(params);
      const quantity = event.srcElement.value;

      // Update quantity parameter with the new quantity
      searchParams.set('quantity', quantity);

      // Pass the parameters back to the url params
      url.search = searchParams.toString();

      // Update the href in the button
      customerAddToCartButton.href = url.toString();
    });
  }


  /**
   * Simulate change events for the optional products
   * This solves the design issues we had with the add to cart being in a different location than the rest.
   */
  simulateSimilarInputChanges('input.optional-products-checkbox', 'checkbox', true);


  /**
   * When clicking on a optional product checkbox
   * This will add the price of the product selected to the price of the product
   */
  Array.from(document.querySelectorAll('.entry-summary .optional-products-wrapper input.optional-products-checkbox')).forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      // Fetching the price from the input field
      let { price } = checkbox.dataset;
      price = parseFloat(price);

      // Find the current price
      const priceWrapper = document.querySelector('.product .entry-summary .price');
      const oldPrice = findPrice(priceWrapper);

      if (checkbox.checked) {
        // If user just checked the checkbox, add the price to the total
        updatePrice(priceWrapper, oldPrice + price);
      } else {
        // If the user unchecked it, remove the price of the optional product from the total
        updatePrice(priceWrapper, oldPrice - price);
      }
    });
  });


  /**
   * This is used to solve the design on subscription products
   * Adding a "Fake" option in the list for subscription
   */
  const WCSubscriptionInitializer = () => {
    const WCSubscriptionOptions = document.querySelector('.cart .wcsatt-options-wrapper .wcsatt-options-product');
    if (WCSubscriptionOptions && typeof subscriptionProductOptions !== 'undefined') {
      const oneTimeOption = WCSubscriptionOptions.querySelector('.one-time-option');
      const firstSubscriptionRow = WCSubscriptionOptions.querySelector('.subscription-option');
      const firstSubscriptionInput = firstSubscriptionRow.querySelector('input');

      // Insert the subscription button
      firstSubscriptionRow.insertAdjacentHTML('beforebegin', subscriptionProductOptions.button);

      const subscriptionFaker = WCSubscriptionOptions.querySelector('.subscription-option-faker');
      const fakeCheckbox = subscriptionFaker.querySelector('.subscription-option-faker-checkbox');

      setTimeout(() => {
        const subscriptionIntervalFaker = document.querySelector('select[name="subscription_interval_selector_faker"]');
        if (subscriptionIntervalFaker) {
          subscriptionIntervalFaker.addEventListener('change', (event) => {
            event.preventDefault();
            fakeCheckbox.click();
            const subscriptionInterval = document.querySelector(`input[name^="convert_to_sub_"][value="${subscriptionIntervalFaker.value}"]`);
            if (subscriptionInterval) {
              subscriptionInterval.click();
            }
          });
        }

        fakeCheckbox.addEventListener('change', () => {
          if (fakeCheckbox.checked) {
            if (subscriptionIntervalFaker) {
              const subscriptionInterval = document.querySelector(`input[name^="convert_to_sub_"][value="${subscriptionIntervalFaker.value}"]`);
              if (subscriptionInterval) {
                subscriptionInterval.click();
              }
            } else {
              firstSubscriptionInput.checked = true;
            }

            const priceWrapper = document.querySelector('.product .entry-summary .price');
            const newPriceWrapper = subscriptionFaker.querySelector('.subscription-option-faker-details');
            const newPrice = findPrice(newPriceWrapper);
            updatePrice(priceWrapper, newPrice);

            document.body.classList.add('have-chosen-subscription-option');
          } else {
            fakeCheckbox.checked = true;
          }
        });
      }, 10);


      // When a user click's on "one time delivery", remove the checked from the faker checkbox
      if (oneTimeOption) {
        const oneTimeInput = oneTimeOption.querySelector('input');

        oneTimeInput.addEventListener('change', () => {
          if (oneTimeInput.checked) {
            const priceWrapper = document.querySelector('.product .entry-summary .price');
            const newPriceWrapper = oneTimeOption.querySelector('.one-time-option-details');
            const newPrice = findPrice(newPriceWrapper);
            updatePrice(priceWrapper, newPrice);

            fakeCheckbox.checked = false;
            document.body.classList.remove('have-chosen-subscription-option');
          }
        });
      }
    }
  };
  WCSubscriptionInitializer();

  /**
   * Synchronize the price changes to other locations
   * When the main price of a product is changed, synchronize those changes to a other locations as well.
   */
  const priceData = document.querySelector('.entry-summary .price');
  if (priceData) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length > 0 && mutation.removedNodes.length === 0) {
          const headerPrice = findPriceNode('.product-header .price');
          const stickyPrice = findPriceNode('.sticky-product-inner .product-price > .price');
          if (headerPrice) {
            headerPrice.innerHTML = mutation.addedNodes[0].innerHTML;
          }
          if (stickyPrice) {
            stickyPrice.innerHTML = mutation.addedNodes[0].innerHTML;
          }
        }
      });
    });

    const observerConfig = {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    };

    observer.observe(priceData, observerConfig);
  }


  /**
   * Add the scroll to and open description event
   * For some reason, this had to be inside of a timout event, never figured out why
   */
  setTimeout(() => {
    Array.from(document.getElementsByClassName('scroll-to-description')).forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const descriptionContainer = document.getElementById('accordion-container');

        const firstDraw = descriptionContainer.querySelector('.drawer .accordion-item .accordion-header');

        // Open the description if it's not open
        if (!firstDraw.classList.contains('accordion-header-active')) {
          firstDraw.click();
        }

        scrollTo(descriptionContainer.offsetTop + 150, 600);
      });
    });
  }, 100);


  /**
   * When clicking on the "buy" button in the sticky header on product pages,
   * simulate the click event on the real add to cart button.
   */
  document.getElementById('sticky-add-to-cart-button').addEventListener('click', () => {
    document.querySelector('.cart .single_add_to_cart_button').click();
  });

  const fetchComments = () => {
    const reviewsContainer = document.getElementById('reviews');

    if (!reviewsContainer) {
      return;
    }

    // The ajax request payload
    const payload = {
      action: 'maksimer_product_get_review_output',
      post_id: document.body.dataset.postId,
    };

    // Get age filters
    const ageFilters = Array.from(document.querySelectorAll('.review-filter.filter-age input.filter_age:checked'));
    if (ageFilters && ageFilters.length > 0) {
      const ages = [];
      ageFilters.forEach((age) => {
        ages.push(age.value);
      });
      payload.ages = ages;
    } else {
      alert(translation.comments.missing_age);
      return;
    }

    // Get skin type filters
    const skinTypeFilters = Array.from(document.querySelectorAll('.review-filter.filter-skin_type input.filter_skin_type:checked'));
    if (skinTypeFilters && skinTypeFilters.length > 0) {
      const skinTypes = [];
      skinTypeFilters.forEach((skinType) => {
        skinTypes.push(skinType.value);
      });
      payload.skin_types = skinTypes;
    } else {
      alert(translation.comments.missing_skin_type);
      return;
    }

    // Get rating filters
    const ratingsFilters = Array.from(document.querySelectorAll('.review-filter.filter-ratings input.filter_rating:checked'));
    if (ratingsFilters && ratingsFilters.length > 0) {
      const ratings = [];
      ratingsFilters.forEach((rating) => {
        ratings.push(rating.value);
      });
      payload.ratings = ratings;
    } else {
      alert(translation.comments.missing_rating);
      return;
    }

    const comments = document.getElementById('comments');
    const loadingHtml = loader();
    comments.innerHTML = loadingHtml.innerHTML;

    jQuery.post(translation.ajaxurl, payload, (res) => {
      comments.innerHTML = res;

      const commentsList = comments.querySelectorAll('.commentlist > li');
      const fetchMore = comments.querySelector('button.fetch-more-comments');

      const limit = 6;

      if (commentsList.length > 0) {
        commentsList.forEach((comment, index) => {
          if (index < limit) {
            comment.classList.add('display-comment');
          }
        });
      } else {
        comments.innerHTML = translation.comments.not_found;
      }

      if (fetchMore) {
        fetchMore.addEventListener('click', (event) => {
          event.preventDefault();
          const commentsListNotDisplayed = comments.querySelectorAll('.commentlist > li:not(.display-comment)');
          commentsListNotDisplayed.forEach((comment, index) => {
            if (index < limit) {
              comment.classList.add('display-comment');
            }
          });

          if (commentsListNotDisplayed.length - limit <= 0) {
            fetchMore.remove();
          }
        });
      }
    });
  };

  fetchComments();

  const toggleCommentsFilterBtn = document.getElementById('display-comments-filter');
  if (toggleCommentsFilterBtn) {
    toggleCommentsFilterBtn.addEventListener('click', (event) => {
      event.preventDefault();
      document.querySelector('.filter-reviews-wrapper').style.display = 'block';
      toggleCommentsFilterBtn.remove();
    });
  }
  const filterComments = document.getElementById('save-comments-filter');
  if (filterComments) {
    filterComments.addEventListener('click', (event) => {
      event.preventDefault();

      fetchComments();
    });
  }

  /**
   * Display recent viewed products on the product page
   */
  const fetchRecentProducts = () => {
    const recentProducts = JSON.parse(localStorage.getItem('recentProducts'));
    const lastSeenContainer = document.querySelector('.last-seen-products');
    const currentProductID = document.body.dataset.postId;

    if (recentProducts && recentProducts.length > 0) {
      const productIDs = [];

      recentProducts.forEach((product) => {
        if (parseInt(currentProductID, 10) !== product.id && !productIDs.includes(product.id)) {
          productIDs.push(product.id);
        }
      });

      jQuery.post(translation.ajaxurl, { action: 'maksimer_woocommerce_build_product_list', product_ids: productIDs }, (response) => {
        const productList = lastSeenContainer.querySelector('ul.products');
        productList.innerHTML = response;

        lastSeenContainer.querySelector('.products-loading-container').remove();
      });
    } else {
      lastSeenContainer.remove();
    }
  };

  fetchRecentProducts();


  /**
   * Display a popup for skin type test if a users looks at 3+ skin type products without adding any to cart
   */
  const checkSkinTypeProducts = () => {
    // Temp deactivated, requested by Timm and Linda in a meeting 18/06/2021
    return;
    // eslint-disable-next-line no-unreachable
    const seenPopUp = getCookie('skinTypeInfoPopUpHide');

    if (seenPopUp) {
      return;
    }

    if (document.body.classList.contains('skin-type-in-cart')) {
      return;
    }

    const recentProducts = JSON.parse(localStorage.getItem('recentProducts'));
    let skinTypesViewed = 0;

    if (recentProducts) {
      recentProducts.forEach((product) => {
        if (product.category.indexOf('Hudpleie') !== -1) {
          skinTypesViewed += 1;
        }
      });
    }

    // eslint-disable-next-line no-unreachable
    setTimeout(() => {
      if (skinTypesViewed > 3) {
        jQuery.post(translation.ajaxurl, { action: 'maksimer_woocommerce_popup_skin_type_info' }, (response) => {
          setCookie('skinTypeInfoPopUpHide', true, 30);
          const WPFooter = document.querySelector('body > .wp-footer');
          const popup = document.createElement('div');
          popup.innerHTML = response;
          WPFooter.appendChild(popup);

          popup.querySelector('.close-popup').addEventListener('click', (event) => {
            event.preventDefault();
            popup.querySelector('#skin-type-info').classList.remove('open');
          });

          popup.querySelector('.bg').addEventListener('click', () => {
            popup.querySelector('#skin-type-info').classList.remove('open');
          });
        });
      }
    }, 3000);
  };

  checkSkinTypeProducts();

  const addVideoTipIcon = () => {
    const videoContainer = document.getElementById('product-tip-video');

    if (!videoContainer) {
      return;
    }

    const thumbs = document.querySelector('.woocommerce-product-gallery .flex-control-nav');
    if (!thumbs) {
      return;
    }
    const videoThumbnail = document.createElement('li');
    videoThumbnail.classList.add('scroll-to-tip');
    videoThumbnail.innerHTML = '<svg enable-background="new 0 0 1000 1000" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg" style="width: 34px; display: block; margin: 0 auto; cursor: pointer;"><path d="m402 328.5 294 171.5-294 171.5zm98-318.5c-269.5 0-490 220.5-490 490s220.5 490 490 490 490-220.5 490-490-220.5-490-490-490m0 49c245 0 441 196 441 441s-196 441-441 441-441-196-441-441 196-441 441-441"/></svg>';
    thumbs.appendChild(videoThumbnail);

    videoThumbnail.addEventListener('click', (event) => {
      const videoTip = document.querySelector('section.product-tips-wrapper');
      event.preventDefault();
      scrollTo(videoTip.offsetTop, 500);
    });
  };

  setTimeout(() => {
    addVideoTipIcon();
  }, 500);

  // eslint-disable-next-line no-undef,camelcase
  if (typeof pa_ingredienser_data !== 'undefined') {
    // eslint-disable-next-line camelcase,no-undef
    const listOfIngredients = pa_ingredienser_data;
    const allIngredients = document.getElementById('tab-product_contains');

    listOfIngredients.forEach((ingredient) => {
      const strRegExp = new RegExp(ingredient.name, 'ig');

      // eslint-disable-next-line no-undef
      if (strRegExp.test(allIngredients.innerHTML)) {
        const replaceValue = `<a href="#" class="ingredient-toggle-product" data-term-id="${ingredient.term_id}">${ingredient.name}</a>`;
        document.getElementById('tab-product_contains').innerHTML = document.getElementById('tab-product_contains').innerHTML.replaceAll(strRegExp, replaceValue);
      }

      // const strRegExp = new RegExp(ingredient.name, 'g');
      // document.getElementById('tab-product_contains').innerHTML = document.getElementById('tab-product_contains').innerHTML.replace(strRegExp, `<a href="#" class="ingredient-toggle-product" data-term-id="${ingredient.term_id}" data-term-name="${ingredient.name_more}" data-term-description="${ingredient.description}" data-term-link="${ingredient.url}"  data-term-categories="${ingredient.categories}"  data-term-rating="${ingredient.rating}">${ingredient.name}</a>`);
    });

    setTimeout(() => {
      const links = Array.from(document.querySelectorAll('.ingredient-toggle-product'));
      const stars = document.createElement('div');
      stars.innerHTML = '<svg width="100" height="15" viewBox="0 0 150 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.08 2l3.09 6.26 6.91 1.01-5 4.87 1.18 6.88-6.18-3.25-6.18 3.25 1.18-6.88-5-4.87 6.91-1.01L12.08 2z" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M40.75 2l3.09 6.26 6.91 1.01-5 4.87 1.18 6.88-6.18-3.25-6.18 3.25 1.18-6.88-5-4.87 6.91-1.01L40.75 2z" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M67.5 2l3.09 6.26 6.91 1.01-5 4.87 1.18 6.88-6.18-3.25-6.18 3.25 1.18-6.88-5-4.87 6.91-1.01L67.5 2z" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M94.25 2l3.09 6.26 6.91 1.01-5 4.87 1.18 6.88-6.18-3.25-6.18 3.25 1.18-6.88-5-4.87 6.91-1.01L94.25 2z" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      if (links) {
        links.forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            const { termId } = link.dataset;

            const ingredient = pa_ingredienser_data.find((term) => term.term_id === parseInt(termId, 0));

            const activeContainer = document.getElementById('active-ingredient');
            scrollTo(activeContainer.offsetTop, 300);

            const wrapperWrapEl = document.createElement('div');
            const wrapperEl = document.createElement('div');
            const titleEl = document.createElement('h4');
            const closeEl = document.createElement('a');
            const descriptionEl = document.createElement('p');
            const categoriesEl = document.createElement('p');
            const ratingEl = document.createElement('p');

            wrapperEl.className = 'ingredient-wrapper';

            closeEl.className = 'ingredient-close';
            closeEl.href = '#';
            closeEl.innerText = 'x';

            wrapperEl.appendChild(closeEl);

            titleEl.innerHTML = link.innerText;
            titleEl.className = 'ingredient-name';
            wrapperEl.appendChild(titleEl);

            if (ingredient.description) {
              descriptionEl.innerText = ingredient.description;
              descriptionEl.className = 'ingredient-description';
              wrapperEl.appendChild(descriptionEl);
            }

            if (ingredient.categories) {
              categoriesEl.innerHTML = `<span class="label">Kategori:</span> ${ingredient.categories}`;
              categoriesEl.className = 'ingredient-categories link-list';
              wrapperEl.appendChild(categoriesEl);
            }

            if (ingredient.rating > 0) {
              ratingEl.innerHTML = `<span class="label">Rating:</span> ${stars.innerHTML}`;
              ratingEl.className = `ingredient-rating link-list rating-${ingredient.rating}`;
              wrapperEl.appendChild(ratingEl);
            }

            wrapperWrapEl.appendChild(wrapperEl);
            activeContainer.innerHTML = wrapperWrapEl.innerHTML;

            triggerEvent(activeContainer, 'product-ingredient-info-toggle');
          });
        });
      }
    }, 100);

    setTimeout(() => {
      const activeContainer = document.getElementById('active-ingredient');
      activeContainer.addEventListener('product-ingredient-info-toggle', () => {
        const closeButton = document.querySelector('#active-ingredient .ingredient-wrapper .ingredient-close');
        closeButton.addEventListener('click', (event) => {
          event.preventDefault();
          const scrollBackTo = document.getElementById('tab-product_contains').offsetTop;
          scrollTo(scrollBackTo, 300);
          activeContainer.innerHTML = '';
        });
      });
    }, 200);
  }


  const buildProductImageSlideNumberIndicator = () => {
    const wrapper = document.querySelector('.product-image-slider');
    if (wrapper) {
      const slides = Array.from(wrapper.querySelectorAll('.woocommerce-product-gallery__image'));
      if (slides) {
        wrapper.classList.add(`slides-${slides.length}`);

        let counter = 1;
        slides.forEach((slide) => {
          const slideIndicator = document.createElement('span');
          slideIndicator.className = 'slide-indicator';
          slideIndicator.innerText = `${counter}/${slides.length}`;
          slide.appendChild(slideIndicator);

          counter += 1;
        });
      }
    }
  };
  buildProductImageSlideNumberIndicator();


  const checkStickyExtraButton = () => {
    const haveButton = document.querySelector('.choose-color-sticky .cart .custom-extra-product-page-button');

    if (haveButton) {
      const wrapper = document.querySelector('.choose-color-sticky');
      if (wrapper) {
        wrapper.classList.add('contains-extra-button');
      }
    }
  };
  checkStickyExtraButton();
  jQuery(document.body).on('variable-product-changed-product', checkStickyExtraButton);
}
